import setSiteMeta from '../base-saving-actions/set-site-meta';

const updateCustomTextColors = (colors) =>
  setSiteMeta(['customization', 'customTextColors'], colors);

export default updateCustomTextColors;
